import { z } from 'zod';
import superjson from 'superjson';
import { SessionStatus } from '../../helpers/schema';

export const schema = z.object({});

export type InputType = z.infer<typeof schema>;

export type FavoriteItem = {
  sessionId: string;
  createdAt: Date | string | null;
  session: {
    id: string;
    name: string;
    status: SessionStatus;
  };
};

export type OutputType = {
  favorites: FavoriteItem[];
};

export const getFavoritesList = async (init?: RequestInit): Promise<OutputType> => {
  const result = await fetch(`/_api/favorites/list`, {
    method: 'GET',
    credentials: 'include',
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...(init?.headers ?? {}),
    },
  });
  if (!result.ok) {
    const errorObject = superjson.parse<{ error: string }>(await result.text());
    throw new Error(errorObject.error);
  }
  return superjson.parse<OutputType>(await result.text());
};
